(function(){
  function q(id){return document.getElementById(id);}
  var overlay, drawer;
  function openCart(e){ if(e)e.preventDefault(); overlay.classList.add('open'); drawer.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeCart(){ overlay.classList.remove('open'); drawer.classList.remove('open'); document.body.style.overflow=''; }
  function money(c){ return (c/100).toLocaleString('fr-FR',{minimumFractionDigits:2,maximumFractionDigits:2})+' €'; }

  function renderCart(cart){
    var box=q('cartItems'); if(!box) return;
    if(!cart.item_count){
      box.innerHTML='<div class="cart-empty">Votre panier est vide.</div>';
    } else {
      var h='';
      cart.items.forEach(function(it){
        h+='<div class="cart-item"><img src="'+it.image+'" alt=""><div class="ci-info">'
          +'<div class="ci-name">'+it.product_title+'</div>'
          +'<div class="ci-var">'+(it.variant_title||'')+'</div>'
          +'<div class="ci-bottom"><div>Qté '+it.quantity+'</div><div class="ci-price">'+money(it.final_line_price)+'</div></div>'
          +'<button class="ci-remove" type="button" data-key="'+it.key+'">Retirer</button></div></div>';
      });
      box.innerHTML=h;
    }
    var sub=q('cartSubtotal'); if(sub) sub.textContent=money(cart.total_price);
    var cc=q('cartCount'); if(cc){ cc.textContent=cart.item_count; cc.hidden=(cart.item_count===0); }
  }
  function refresh(open){ return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ renderCart(c); if(open) openCart(); }); }

  document.addEventListener('DOMContentLoaded', function(){
    overlay=q('cartOverlay'); drawer=q('cartDrawer');
    var toggle=q('cartToggle'); if(toggle) toggle.addEventListener('click', openCart);
    var close=q('cartClose'); if(close) close.addEventListener('click', closeCart);
    if(overlay) overlay.addEventListener('click', closeCart);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeCart(); });

    // AJAX add to cart
    document.addEventListener('submit', function(e){
      var f=e.target;
      if(f.matches && f.matches('form[action$="/cart/add"], form[action*="/cart/add"]')){
        e.preventDefault();
        var btn=f.querySelector('[type=submit]'); if(btn) btn.disabled=true;
        fetch('/cart/add.js',{method:'POST',body:new FormData(f),headers:{'Accept':'application/json'}})
          .then(function(r){ if(!r.ok) throw 0; return r.json(); })
          .then(function(){ return refresh(true); })
          .catch(function(){ f.submit(); })
          .then(function(){ if(btn) btn.disabled=false; });
      }
    });

    // AJAX remove
    document.addEventListener('click', function(e){
      var b=e.target.closest ? e.target.closest('.ci-remove[data-key]') : null;
      if(b){ e.preventDefault();
        fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:b.getAttribute('data-key'),quantity:0})})
          .then(function(r){return r.json();}).then(renderCart);
      }
    });

    // accordions
    document.querySelectorAll('.acc-head').forEach(function(h){ h.addEventListener('click', function(){ h.parentElement.classList.toggle('open'); }); });
  });
})();
